import { render, staticRenderFns } from "./Association.vue?vue&type=template&id=6dec877c&scoped=true"
import script from "./Association.vue?vue&type=script&lang=js"
export * from "./Association.vue?vue&type=script&lang=js"
import style0 from "./Association.vue?vue&type=style&index=0&id=6dec877c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6dec877c",
  null
  
)

export default component.exports